import { render, staticRenderFns } from "./datatables_onlineclass_karuniarohani.vue?vue&type=template&id=2a286d8c&"
import script from "./datatables_onlineclass_karuniarohani.vue?vue&type=script&lang=js&"
export * from "./datatables_onlineclass_karuniarohani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports